import { faIdCard } from '@fortawesome/pro-regular-svg-icons/faIdCard'
import { Text, Flex } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type UNSAFE_any } from '@flecto/types'
import { Icon, Modal } from '@flecto/ui'

export const ModalConfirmChangeDocument = ({
  newDocument,
  newDocumentType,
  customer,
  saveCustomer,
}: UNSAFE_any) => {
  const { t } = useTranslation('saas', { keyPrefix: 'customers' })
  return (
    <Modal>
      <Modal.Icon variant='warning' />
      <Modal.Title>{t('change_document_modal.title')}</Modal.Title>
      <Modal.Subtitle>{t('change_document_modal.description')}</Modal.Subtitle>
      <Modal.Content>
        <Flex gap={'sm'} align={'center'}>
          <Icon icon={faIdCard} color='gray.5' />
          <Text variant='dimmed' td='line-through' c='gray.5'>
            {`${t(`document_type.${customer.id_document_type}`)} #${
              customer.id_document_number
            }`}
          </Text>
        </Flex>
        <Flex gap='sm' align={'center'}>
          <Icon icon={faIdCard} color='green.5' />
          <Text c='green.7'>
            {`${t(`document_type.${newDocumentType}`)} #${newDocument}`}
          </Text>
        </Flex>
      </Modal.Content>
      <Modal.Cancel />
      <Modal.Submit onClick={() => saveCustomer()} />
    </Modal>
  )
}
